export default {
  data() {
    return {
      // isLoading: false,
    }
  },
  methods: {
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this));
    },
  }
}